export function obterListaCteCargaCUnid() {
  return (
    [
      { label: '00 - Metro Cúbico', value: 'M3' },
      { label: '01 - Quilo', value: 'KG' },
      { label: '02 - Tonelada', value: 'TON' },
      { label: '03 - Unidade', value: 'UN' },
      { label: '04 - Litros', value: 'LT' },
      { label: '05 - MMBTU', value: 'MMBTU' },
    ]
  );
}
